// extracted by mini-css-extract-plugin
export default {"container":"FK-z","error":"GK-z","disabled":"HK-z","submit":"IK-z","option":"JK-z","success":"KK-z","failure":"LK-z"};